import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import { default as Map } from "./code-map";
import { default as Editor } from "./code-map-editor";
import { default as Cong } from "./code-map-cong";

const styles = theme => ({
  editor: {
    left: "-2px"
  },
  cmdsWrap: {
    height: "40px"
  },
  cmds: {
    float: "right",
    paddingRight: "20px"
  }
});

@observer
class CodeMapPanel extends Component {
  //===========================================================================
  @observable height = "100";
  @observable code = "";
  @observable editor = 0;
  @observable stepValue = "1";
  //===========================================================================

  render() {
    const { codeMapStore, authStore } = this.props.rootStore;
    const { codeMaps, mapInfo } = codeMapStore;

    return (
      <div className="full-box">
        <div className="step-line">
          <span className="step-count">진행단계</span>
          {codeMaps.map(codeMap => {
            return (
              <a
                href={"#" + codeMap.step}
                onClick={() => this.step(codeMap.uid)}
                key={codeMap.uid}
              >
                <span
                  className={
                    "step-ball " +
                    (mapInfo.step === codeMap.step
                      ? "status-now"
                      : true
                      ? "status-not-try"
                      : "status-complete")
                  }
                >
                  {codeMap.step}
                </span>
              </a>
            );
          })}

          <span className="step-btn">
            <a href="#play" onClick={this.play}>
              <i className="fas fa-play" />
            </a>
            <a href="#redo" onClick={this.redo}>
              <i className="fas fa-redo" />
            </a>
          </span>
        </div>
        <div className={this.props.classes.cmdsWrap}>
          <div className={this.props.classes.cmds}>
            {mapInfo.cmds
              ? mapInfo.cmds.map(cmd => (
                  <Button
                    key={cmd.name}
                    onClick={() => {
                      this.handleSyntax(cmd.syntax);
                    }}
                    variant="outlined"
                  >
                    {cmd.name}
                  </Button>
                ))
              : ""}
          </div>
        </div>

        <div className="half-box1">
          <div className="checkerboard">
            <div className="inner">
              <Map
                innerRef={node => (this._map = node)}
                info={mapInfo}
                changeCodeMirrorHeight={this.changeCodeMirrorHeight}
                handleOpenSuccessForm={this.openSuccessForm}
              />
            </div>
          </div>
        </div>

        <div className="half-box2">
          <div className="checkerboard">
            <div className="inner2">
              <Editor
                innerRef={node => (this._editor = node)}
                code={this.code}
                editor={this.editor}
                changeCode={this.changeCode}
              />
            </div>
          </div>
        </div>

        <Cong
          innerRef={node => (this._cong = node)}
          authStore={authStore}
          step={this.stepValue}
        />
      </div>
    );
  }
  //===========================================================================
  /**
   * 입력값 설정
   */
  @action
  changeCodeMirrorHeight = height => {
    this.height = height;
    if (document.querySelector(".CodeMirror"))
      document.querySelector(".CodeMirror").style.height = height + "px";
    this.editor++;
  };
  openSuccessForm = () => {
    this._cong.openCong(this.stepValue);
  };
  @action
  handleSyntax = syntax => {
    this.code = this.code ? this.code + "\n" + syntax : syntax;
    this.editor++;
  };
  @action
  initCode = () => {
    const { codeMapStore } = this.props.rootStore;
    this.stepValue = codeMapStore.mapInfo.step;
    this.code = "";
    if (document.querySelector(".CodeMirror"))
      document.querySelector(".CodeMirror").style.height = this.height + "px";
  };
  //===========================================================================
  step = uid => {
    const { codeMapStore } = this.props.rootStore;
    codeMapStore.changeCodeMap(uid);
    this.initCode();
  };
  play = () => {
    try {
      eval(this.code);
      this._map.handlePlay();
    } catch (e) {
      alert(e.message);
    }
  };
  redo = () => {
    this._map.handleDefault();
  };
  @action
  changeCode = code => {
    this.code = code;
  };
  //===========================================================================
}

export default withStyles(styles)(CodeMapPanel);
